module.exports = __webpack_public_path__ + "static/media/md-paw.3fc1ee09.svg";